module.exports = __webpack_public_path__ + "static/media/galerija_2017 (6).0e63261e.jpg";